import FormItem from "@components/FormItem/FormItem";
import FormSection from "@components/FormSection/FormSection";
import type { VesselNominationOutletContext } from "@features/vessel-nomination/add/constants";
import { FORM_FIELDS } from "@features/vessel-nomination/add/constants";
import type { VesselNominationFormData } from "@features/vessel-nomination/add/schema/vesselNominationFormSchema";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { LANG_BASE } from "../PreArrivalQuestionnaire";

const LastPscInspection = () => {
  const { t } = useTranslation();
  const { formData, updateFormData } = useOutletContext<VesselNominationOutletContext>();

  return (
    <FormProvider {...formData}>
      <FormSection
        title={t(`${LANG_BASE}.sections.last-psc-inspection`)}
        className="grid-cols-1 lg:grid-cols-2"
      >
        <FormItem<VesselNominationFormData, typeof FORM_FIELDS.LAST_PSC_INSPECTION>
          testId="nomination-last-psc-inspection-input"
          name={FORM_FIELDS.LAST_PSC_INSPECTION}
          type="date-picker"
          label={t(`${LANG_BASE}.fields.date`)}
          onFieldChange={updateFormData}
          dateConstraint="not-future"
          timePicker={false}
        />
        <FormItem<VesselNominationFormData, typeof FORM_FIELDS.PLACE>
          testId="nomination-place-input"
          name={FORM_FIELDS.PLACE}
          type="text"
          label={t(`${LANG_BASE}.fields.place`)}
          onFieldChange={updateFormData}
          maxChars={50}
        />
      </FormSection>
    </FormProvider>
  );
};

export default LastPscInspection;
